// removed by extract-text-webpack-plugin
module.exports = {"css-modules-nav-example":"_318SyK-1cB18VSKZzgkC_T","the-css-module-class":"_1M30G--RyGN696FKrWwtnK"};


/*****************
 ** WEBPACK FOOTER
 ** ./examples/example.module.css
 ** module id = 515
 ** module chunks = 0
 **/